import {clsx} from 'clsx'
import {LogoMarquee, type LogoMarqueeProps} from '../../generic/LogoMarquee/LogoMarquee'
import {Testimonials, type TestimonialsProps} from '../../generic/Testimonials/Testimonials'
import Styles from './TestimonialsSection.module.css'
import {Grid} from '@primer/react-brand/esm'

export interface TestimonialsSectionProps {
  data: TestimonialsProps
  logoMarquee: LogoMarqueeProps
}

export const defaultProps: Partial<TestimonialsSectionProps> = {}

export const TestimonialsSection = (props: TestimonialsSectionProps) => {
  const initializedProps: TestimonialsSectionProps = {...defaultProps, ...props}
  const {data, logoMarquee} = initializedProps

  return (
    <div className={Styles.TestimonialsSection}>
      <div className={Styles.TestimonialsSection__testimonials}>
        <div className={Styles.TestimonialsSection__gridContent}>
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            <Grid.Column span={12} className={Styles.TestimonialsSection__gridColumn}>
              <Testimonials {...data} />
            </Grid.Column>
          </Grid>
        </div>
      </div>
      <div className={Styles.TestimonialsSection__logoMarquee}>
        <div
          className={clsx(
            Styles['TestimonialsSection__gridContent'],
            Styles['TestimonialsSection__gridContent--mobileFullWidth'],
          )}
        >
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            <Grid.Column span={12} className={Styles.TestimonialsSection__gridColumn}>
              <LogoMarquee {...logoMarquee} />
            </Grid.Column>
          </Grid>
        </div>
      </div>

      <div className={Styles['TestimonialsSection__Spacer']} />
    </div>
  )
}
